// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let ReasonPromise = require("../../reason/ReasonPromise.bs.js");
let Utils__Promise = require("../../utils/Utils__Promise.bs.js");
let Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");

let validators_password = {
  strategy: "OnFirstBlur",
  validate: (param, param$1) => {
    let password = param.password;
    if (password === "") {
      return {
        TAG: "Error",
        _0: "is required"
      };
    } else {
      return {
        TAG: "Ok",
        _0: password
      };
    }
  }
};

let validators_email = {
  strategy: "OnFirstBlur",
  validate: (param, param$1) => {
    let email = param.email;
    if (email === "") {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
    let ok = Scalars.EmailAddress.validate(email);
    if (ok.TAG === "Ok") {
      return ok;
    } else {
      return {
        TAG: "Error",
        _0: "must be a valid email address"
      };
    }
  },
  validateAsync: Formality__Debouncer.make(700, param => {
    let dispatch = param[2];
    let value = param[0];
    let validate = (email, param) => Utils__Promise.toJsPromise(ReasonPromise.map(ReasonPromise.map(param.queryEmailAddress(email), v => {
      if (v.TAG !== "Ok") {
        return {
          TAG: "Error",
          _0: "there was an error connecting to our servers"
        };
      }
      let tmp = v._0;
      if (tmp === "AVAILABLE" || tmp === "REGISTERED") {
        if (tmp === "AVAILABLE") {
          return {
            TAG: "Error",
            _0: "email is not registered"
          };
        } else {
          return {
            TAG: "Ok",
            _0: email
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: "there was an error connecting to our servers"
        };
      }
    }), v => ({
      TAG: "Ok",
      _0: v
    })));
    Formality.Async.validateAsyncWithMetadata(value, param[1], validate, res => dispatch({
      TAG: "ApplyAsyncResultForEmailField",
      _0: value,
      _1: res
    }));
  }),
  eq: (a, b) => a === b
};

let validators = {
  rememberMe: undefined,
  password: validators_password,
  email: validators_email
};

function initialFieldsStatuses(input) {
  return {
    rememberMe: "Pristine",
    password: "Pristine",
    email: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    rememberMe: "Pristine",
    password: "Pristine",
    email: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      rememberMe: "Pristine",
      password: "Pristine",
      email: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  let match_0 = {
    TAG: "Ok",
    _0: input.rememberMe
  };
  let match = fieldsStatuses.password;
  let tmp;
  tmp = typeof match !== "object" ? validators.password.validate(input, metadata) : match._0;
  let value = fieldsStatuses.email;
  let tmp$1;
  tmp$1 = typeof value !== "object" ? ({
      NAME: "Result",
      VAL: validators.email.validate(input, metadata)
    }) : (
      value.TAG === "Dirty" ? ({
          NAME: "Result",
          VAL: value._0
        }) : ({
          NAME: "Validating",
          VAL: value._0
        })
    );
  let rememberMeResult = match_0;
  let exit = 0;
  let emailResult = tmp$1;
  if (typeof emailResult === "object") {
    if (emailResult.NAME === "Validating") {
      return {
        TAG: "Validating",
        fieldsStatuses: {
          rememberMe: {
            TAG: "Dirty",
            _0: rememberMeResult,
            _1: "Hidden"
          },
          password: {
            TAG: "Dirty",
            _0: tmp,
            _1: "Shown"
          },
          email: emailResult.NAME === "Result" ? ({
              TAG: "Dirty",
              _0: emailResult.VAL,
              _1: "Shown"
            }) : ({
              TAG: "Validating",
              _0: emailResult.VAL
            })
        },
        collectionsStatuses: undefined
      };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2 && rememberMeResult.TAG === "Ok") {
    let passwordResult = tmp;
    if (passwordResult.TAG === "Ok") {
      let match$1 = tmp$1;
      if (typeof match$1 === "object" && match$1.NAME === "Result") {
        let emailResult$1 = match$1.VAL;
        if (emailResult$1.TAG === "Ok") {
          return {
            TAG: "Valid",
            output: {
              email: emailResult$1._0,
              password: passwordResult._0,
              rememberMe: rememberMeResult._0
            },
            fieldsStatuses: {
              rememberMe: {
                TAG: "Dirty",
                _0: rememberMeResult,
                _1: "Hidden"
              },
              password: {
                TAG: "Dirty",
                _0: passwordResult,
                _1: "Shown"
              },
              email: {
                TAG: "Dirty",
                _0: emailResult$1,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
        }
      }
    }
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      rememberMe: {
        TAG: "Dirty",
        _0: rememberMeResult,
        _1: "Hidden"
      },
      password: {
        TAG: "Dirty",
        _0: tmp,
        _1: "Shown"
      },
      email: {
        TAG: "Dirty",
        _0: tmp$1.VAL,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, metadata, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurRememberMeField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.rememberMe, state.fieldsStatuses.rememberMe, status => {
            let init = state.fieldsStatuses;
            return {
              rememberMe: status,
              password: init.password,
              email: init.email
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPasswordField" :
          let result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.password, validators_password, status => {
            let init = state.fieldsStatuses;
            return {
              rememberMe: init.rememberMe,
              password: status,
              email: init.email
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurEmailField" :
          let result$2 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, status => {
            let init = state.fieldsStatuses;
            return {
              rememberMe: init.rememberMe,
              password: init.password,
              email: status
            };
          });
          if (result$2 === undefined) {
            return "NoUpdate";
          }
          let value = result$2.email;
          if (typeof value === "object" && value.TAG !== "Dirty") {
            let value$1 = value._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_email.validateAsync([
                value$1,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: result$2,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
          break;
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let apply_validate = validateForm;
          let match$1 = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
          switch (match$1.TAG) {
            case "Valid" :
              let output = match$1.output;
              let error = state.formStatus;
              let tmp;
              tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
              return {
                TAG: "UpdateWithSideEffects",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: {
                    TAG: "Submitting",
                    _0: tmp
                  },
                  submissionStatus: "AttemptedToSubmit"
                },
                _1: param => {
                  let dispatch = param.dispatch;
                  onSubmit(output, {
                    notifyOnSuccess: input => dispatch({
                      TAG: "SetSubmittedStatus",
                      _0: input
                    }),
                    notifyOnFailure: error => dispatch({
                      TAG: "SetSubmissionFailedStatus",
                      _0: error
                    }),
                    reset: () => dispatch("Reset"),
                    dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
                  });
                }
              };
            case "Invalid" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: "Editing",
                  submissionStatus: "AttemptedToSubmit"
                }
              };
            case "Validating" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: state.formStatus,
                  submissionStatus: state.submissionStatus
                }
              };
          }
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateRememberMeField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.rememberMe, status => {
                let init = state.fieldsStatuses;
                return {
                  rememberMe: status,
                  password: init.password,
                  email: init.email
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePasswordField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.password, state.submissionStatus, validators_password, status => {
                let init = state.fieldsStatuses;
                return {
                  rememberMe: init.rememberMe,
                  password: status,
                  email: init.email
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateEmailField" :
          let nextInput$2 = action._0(state.input);
          let nextFieldsStatuses = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$2, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, status => {
            let init = state.fieldsStatuses;
            return {
              rememberMe: init.rememberMe,
              password: init.password,
              email: status
            };
          });
          let value$2 = nextFieldsStatuses.email;
          if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
            let value$3 = value$2._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: nextInput$2,
                fieldsStatuses: nextFieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_email.validateAsync([
                value$3,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: nextFieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "ApplyAsyncResultForEmailField" :
          let validator = validators_email;
          let x = state.fieldsStatuses.email;
          if (typeof x !== "object") {
            return "NoUpdate";
          }
          if (x.TAG === "Dirty") {
            return "NoUpdate";
          }
          if (!validator.eq(x._0, action._0)) {
            return "NoUpdate";
          }
          let init = state.fieldsStatuses;
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: {
                rememberMe: init.rememberMe,
                password: init.password,
                email: {
                  TAG: "Dirty",
                  _0: action._1,
                  _1: "Shown"
                }
              },
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  rememberMe: "Pristine",
                  password: "Pristine",
                  email: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  rememberMe: "Pristine",
                  password: "Pristine",
                  email: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateRememberMe: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateRememberMeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePassword: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePasswordField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateEmail: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateEmailField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurRememberMe: () => dispatch("BlurRememberMeField"),
    blurPassword: () => dispatch("BlurPasswordField"),
    blurEmail: () => dispatch("BlurEmailField"),
    rememberMeResult: Formality.exposeFieldResult(state.fieldsStatuses.rememberMe),
    passwordResult: Formality.exposeFieldResult(state.fieldsStatuses.password),
    emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.rememberMe;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.password;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.email;
      return typeof tmp$2 === "object";
    },
    valid: () => {
      let apply_validate = validateForm;
      let match = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
      switch (match.TAG) {
        case "Valid" :
          return true;
        case "Invalid" :
          return false;
        case "Validating" :
          return;
      }
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let debounceInterval = 700;

let initialCollectionsStatuses;

exports.debounceInterval = debounceInterval;
exports.validators = validators;
exports.initialFieldsStatuses = initialFieldsStatuses;
exports.initialFieldStatuses_xxx = initialFieldStatuses_xxx;
exports.initialCollectionsStatuses = initialCollectionsStatuses;
exports.initialState = initialState;
exports.validateForm = validateForm;
exports.useForm = useForm;
/* validators Not a pure module */
